import { Box, Stack } from '@mui/system'
import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import { useParams } from 'react-router'
import fetchfromAPI from '../utils/fetchfromAPI'
import "../index.css"
import { Typography } from '@mui/material'
import { CheckCircle } from '@mui/icons-material'
import Video from './Feed/Video'

const VideoDetail = () => {
  const [video, setVideo] = useState(null)
  const [videoDetail, setVideoDetail] = useState(null)
  const { id } = useParams()
  useEffect(() => {
    fetchfromAPI(`videos?part=snippet,statistics&id=${id}`).then((data) => {
      setVideo(data.items[0])
    })
    fetchfromAPI(`search?part=snippet&relatedToVideoId=${id}&type=video`).then((data)=>setVideoDetail(data.items))

  }, [id])
  // console.log(video);
  if(!video?.snippet) return "Loading..."
  const { snippet: { title, channelTitle }, statistics: { viewCount, likeCount } } = video
  return (
    <div>
      <Box minHeight={"92vh"} className="!flex">
        <Stack direction={{ xs: "column", md: "row" }}>
          <Box>
            <Box sx={{ width: "100%", position: "sticky", top: "-68px" }}>
              <ReactPlayer url={`https://www.youtube.com/watch?v=${id}`} className="react-player" controls />
              <Typography className="px-8 !mt-3 !font-bold " variant='subtitle1' >{title}</Typography>

                <Stack direction={"row"} justifyContent="space-between" >
                <Typography className="px-8 !mt-3 !font-bold">{channelTitle} <CheckCircle fontSize='12' /></Typography>

                <Stack direction={"row"} gap="12" alignItems={"center"}>
                <Typography className="px-8  !font-bold " variant='subtitle1' >{parseInt(viewCount).toLocaleString("en-US")} views</Typography>
                <Typography>{parseInt(likeCount).toLocaleString("en-US")} likes</Typography>
                </Stack>
                </Stack>
            </Box>
            <Box>

            </Box>
          </Box>
        </Stack>


        <Box px={2} py={{ md: 1, xs: 5 }} justifyContent="center" alignItems="center">
          <Video videos={videoDetail} direction="column" />
        </Box>
      </Box>
    </div>
  )
}

export default VideoDetail
